module.exports = __webpack_public_path__ + "static/media/14-item-a.a4487f54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/14-item-a.jpg
// module id = 1198
// module chunks = 33